import React, { useEffect, useMemo, useState } from 'react'
import generalClasses from './Settings.module.css'
import { Button } from '../../../components/Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { uploadLogo } from './logoApi'
import { userSelectors } from '../../../redux/userSlice'
import notification from '../../../components/Notification/notification'
import { logoActions, logoSelectors } from './logoSlice'
import PreviewImageUploader from '../../../components/Form/PreviewImageUploader/PreviewImageUploader'
import { Dropzone } from '../../../components/Form/Dropzone/Dropzone'
import { getImageURL } from '../../../util/functions'

const BusinessSettingsLogo = () => {
    const [file, setFile] = useState(null)

    const fileURL = useMemo(() => file && URL.createObjectURL(file), [file])

    //TODO: Make this a general function
    const setFileHelper = newDp => {
        if (file) {
            URL.revokeObjectURL(file)
        }

        setFile(newDp)
    }

    const dispatch = useDispatch()
    const user = useSelector(userSelectors.userDetails)

    const success = useSelector(logoSelectors.success)
    const hasError = useSelector(logoSelectors.hasError)
    const errorMessage = useSelector(logoSelectors.errorMessage)
    const isFetching = useSelector(logoSelectors.isFetching)

    useEffect(() => {
        if (!isFetching) {
            notification.destroy()
            if (success) {
                notification.success({
                    title: 'Uploaded!',
                    description: 'Logo changed successfully',
                })
                dispatch(logoActions.reset())
            } else if (hasError) {
                notification.failure({
                    title: 'Something went wrong',
                    description: errorMessage,
                })
                dispatch(logoActions.reset())
            }
        }
    }, [isFetching])

    const handleSubmit = event => {
        notification.loading({
            title: 'Uploading logo',
        })
        dispatch(uploadLogo({ email: user.email, file }))
    }
    return (
        <form onSubmit={handleSubmit}>
            <div className={generalClasses.formSection}>
                <div className={generalClasses.formSectionDescription}>
                    <h6 className={generalClasses.formSectionTitle}>Logo</h6>
                    <p className={generalClasses.formSectionSubtitle}>
                        Upload a company logo
                    </p>
                </div>
                <div className={generalClasses.formSectionInputs}>
                    <div className={generalClasses.formRowCollapsed}>
                        <label className={generalClasses.inputLabel}>
                            Company Logo
                        </label>
                        <Dropzone
                            onChooseFile={setFileHelper}
                            sizeLimit={5}
                            acceptedFileTypes={['image/*']}
                        />
                        {(file || user.logo) && (
                            <img
                                src={file ? fileURL : getImageURL(user.logo)}
                                alt="Logo"
                                className={generalClasses.companyLogo}
                            />
                        )}
                    </div>
                    <div className={generalClasses.formRow}>
                        <Button
                            type="button"
                            className={generalClasses.submitBtn}
                            disabled={!file}
                            onClick={handleSubmit}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    )
}

export default BusinessSettingsLogo
